import { defineMessages } from 'react-intl';

export const emrSchedullingFrequencyMessages = defineMessages({
  // error
  createEmrSchedullingFrequncyByOperatorId: {
    id: 'messages.customerMessages.createEmrSchedullingFrequncyByOperatorIdError',
    defaultMessage: 'An error occured:',
  },

  // success
  createEmrSchedullingFrequncySuccess: {
    id: 'messages.customerMessages.createEmrSchedullingFrequncyByOperatorIdSuccess',
    defaultMessage: 'Frequencies updated succesfully!',
  },
});
